import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { TopBar } from '../components/TopBar';
import { Nav } from '../components/Nav';
import { Footer } from '../components/Footer';
import { CursorSpotlight } from '../components/CursorSpotlight';
import { getAllDispatches } from '../lib/data';
import type { Dispatch } from '../lib/types';

function shortDate(iso: string | null | undefined): string {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    return `${d.getFullYear()} · ${String(d.getMonth() + 1).padStart(2, '0')}`;
  } catch {
    return '';
  }
}

export function DispatchesIndex() {
  const [rows, setRows] = useState<Dispatch[]>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    (async () => {
      const data = await getAllDispatches();
      setRows(data);
      setLoaded(true);
    })();
  }, []);

  return (
    <div
      style={{
        background: 'var(--paper)',
        color: 'var(--ink)',
        fontFamily: 'var(--font-mono)',
        minHeight: '100vh',
        position: 'relative',
        overflow: 'hidden',
        fontSize: 12,
        lineHeight: 1.55,
      }}
    >
      <CursorSpotlight />
      <TopBar />
      <Nav />
      <section className="section" style={{ padding: '56px 28px', minHeight: '60vh' }}>
        <div className="eyebrow" style={{ marginBottom: 16 }}>
          § · Dispatch archive · From the field
        </div>
        <h1
          className="serif italic"
          style={{
            fontSize: 'var(--fs-display)',
            lineHeight: 0.95,
            letterSpacing: -1.8,
            margin: 0,
            marginBottom: 24,
          }}
        >
          Dispatches.
        </h1>
        <div
          className="serif italic"
          style={{ fontSize: 18, opacity: 0.72, marginBottom: 36, maxWidth: 620 }}
        >
          A quarterly letter from wherever I'm filing from. Listening to the customer,
          the team, the quiet signal. Mostly arithmetic after that.
        </div>

        {loaded && rows.length === 0 && (
          <div className="admin-empty">No dispatches published yet.</div>
        )}

        <div>
          {rows.map((d) => (
            <Link
              key={d.id ?? d.slug}
              to={`/dispatches/${d.slug ?? ''}`}
              style={{
                display: 'grid',
                gridTemplateColumns: '110px 1fr auto 60px',
                gap: 24,
                padding: '20px 0',
                borderTop: '1px solid var(--ink)',
                alignItems: 'baseline',
                textDecoration: 'none',
                color: 'inherit',
              }}
            >
              <div className="tabular" style={{ opacity: 0.6 }}>
                {shortDate(d.published_at)}
              </div>
              <div
                className="serif"
                style={{ fontSize: 26, lineHeight: 1.15, letterSpacing: -0.3 }}
              >
                {d.issue_label}
              </div>
              <div className="serif italic" style={{ fontSize: 15, opacity: 0.7 }}>
                Filed · {d.filed_location}
              </div>
              <div style={{ textAlign: 'right', fontSize: 11, opacity: 0.6 }}>
                {d.read_minutes} min
              </div>
            </Link>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
